import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseBgBlurCover',
  setup(__props) {

const visible = ref(false)
onMounted(() => {
  setTimeout(() => {
    visible.value = true
  })
})

return { __sfc: true,visible }
}

})